export default __webpack_public_path__ + "static/media/calendar.1d2703e0.svg";